// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const SweepConfigBody = styled.div`
  padding: 32px 32px 80px;
  width: 80%;
`;
SweepConfigBody.displayName = 'S.SweepConfigBody';

export const ErrorWrapper = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
ErrorWrapper.displayName = 'S.ErrorWrapper';

export const ErrorMessage = styled.div`
  margin: auto;
  color: gray;
  line-height: 24px;
  font-size: 20px;
`;
ErrorMessage.displayName = 'S.ErrorMessage';

export const Value2 = styled.div`
  padding-left: 15px;
  margin-top: 5px;
  margin-bottom: 5px;
`;
Value2.displayName = 'S.Value2';
